import React from 'react';
import './ServiceTypeDivider.css';
import { Divider, Checkbox } from 'antd';

export const ServiceTypeDivider = ({ label, onChange, disabled, checked }) => {
  return (
    <Divider orientation="left" style={{ marginTop: '0' }}>
      <Checkbox disabled={disabled} onChange={e => onChange(e.target.checked)} checked={checked}>
        {label}
      </Checkbox>
    </Divider>
  );
};



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/ServiceTypeDivider/ServiceTypeDivider.js